import { Guid } from "guid-typescript";
import { WorkorderManagementBatch } from "../types/workorderManagementBatch";
import { getNextSixAm } from "./dateHelper";
import { WorkorderManagementData } from "../types/workorderManagementData";

function getNextWorkorderManagementBatch(
    workorderManagementBatches: WorkorderManagementBatch[],
    workorderManagementData: WorkorderManagementData
): WorkorderManagementBatch {
    let dateNow = new Date();

    if (workorderManagementBatches.length === 0) {
        if (workorderManagementData == null) throw new Error("workorderId is empty");
        let next6am = getNextSixAm();
        return {
            workOrderBatchId: Guid.create().toString(),
            workOrderId: workorderManagementData.workorderId,
            day: 1,
            batch: 1,
            lot: 1,
            year: next6am.year(),
            shiftStart: next6am.toDate(),
            shiftEnd: next6am.add(1, "days").toDate(),
            created: dateNow,
            siteId: workorderManagementData.siteId,
            updated: dateNow
        };
    }

    const maxDay = Math.max(...workorderManagementBatches.map(item => item.day));
    const maxBatch = Math.max(...workorderManagementBatches.map(item => item.batch));
    const maxBatchEndsWithTen = Math.floor(maxBatch/10) * 10
    const maxShiftStart = new Date(Math.max(...workorderManagementBatches.map(item => new Date(item.shiftStart).getTime())));
    const maxShiftEnd = new Date(Math.max(...workorderManagementBatches.map(item => new Date(item.shiftEnd ??  new Date()).getTime())));

    const newWorkOrder: WorkorderManagementBatch = {
        ...workorderManagementBatches[0],
        workOrderBatchId: Guid.create().toString(),
        day: maxDay + 1,
        batch: maxBatchEndsWithTen + 10,
        shiftStart: new Date(maxShiftStart.setDate(maxShiftStart.getDate() + 1)),
        shiftEnd: new Date(maxShiftEnd.setDate(maxShiftEnd.getDate() + 1)),
        updated: dateNow,
        created: dateNow
    };

    return newWorkOrder;
}

export { getNextWorkorderManagementBatch };
